import React, { useState } from "react";
import "./navbar.css";
import { RiMenu3Line, RiCloseLine } from "react-icons/ri";
import logo from "../../assets/logo.svg";
import { AnimatePresence, motion, useScroll, useSpring } from "framer-motion";

const navMenuVariant = {
  visible: {
    y: 20,
    opacity: 1,
  },
  hidden: {
    y: 0,
    opacity: 0,
  },
};

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [color, setColor] = useState(false);
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  const conditionalRenderVariant = toggleMenu ? navMenuVariant : "";

  const changeColor = () => {
    if (window.scrollY >= 70) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  React.useEffect(() => {
    window.addEventListener("scroll", changeColor);

    return () => window.removeEventListener("scroll", changeColor);
  }, []);

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.5,
      },
    },
  };

  const Menu = () => (
    <>
      <motion.p
        variants={conditionalRenderVariant}
        initial="hidden"
        animate="visible"
      >
        <a href="#home">Home</a>
      </motion.p>
      <motion.p
        variants={conditionalRenderVariant}
        initial="hidden"
        animate="visible"
      >
        <a href="#wgpt3">What is GPT3</a>
      </motion.p>
      <motion.p
        variants={conditionalRenderVariant}
        initial="hidden"
        animate="visible"
      >
        <a href="#possibility">Open AI</a>
      </motion.p>
      <motion.p
        variants={conditionalRenderVariant}
        initial="hidden"
        animate="visible"
      >
        <a href="#features">Case Studies</a>
      </motion.p>
      <motion.p
        variants={conditionalRenderVariant}
        initial="hidden"
        animate="visible"
      >
        <a href="#blog">Library</a>
      </motion.p>
    </>
  );

  const backdrop = {
    visible: {
      opacity: 1,
      x: [300, 0],
      transition: {
        type: "spring",
        duration: 0.4,
        damping: 15,
        stiffness: 100,
      },
    },
    hidden: {
      opacity: 0,
      x: [0, 300],
      transition: {
        duration: 0.4,
      },
    },
  };

  return (
    <motion.div
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        type: "spring",
        stiffness: 400,
        damping: 67,
        duration: 4,
        ease: "easeOut",
      }}
      className={!color ? "gpt3__navbar" : "gpt3__navbar-color"}
    >
      <div className="gpt3__navbar-links">
        <div className="gpt3__navbar-links_logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="gpt3__navbar-links_container">
          <Menu />
        </div>
      </div>
      <div className="gpt3__navbar-sign">
        <motion.p
          whileHover={{
            scale: 1.1,
          }}
        >
          Sign in
        </motion.p>
        <motion.button
          whileHover={{
            scale: 1.1,
          }}
        >
          Sign up
        </motion.button>
      </div>
      <div className="gpt3__navbar-menu">
        {toggleMenu ? (
          <RiCloseLine
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(false)}
          />
        ) : (
          <RiMenu3Line
            color="#fff"
            size={27}
            onClick={() => setToggleMenu(true)}
          />
        )}
        <AnimatePresence>
          {toggleMenu && (
            <motion.div
              className="gpt3__navbar-menu_container "
              variants={backdrop}
              initial="hidden"
              animate="visible"
              exit="hidden"
            >
              <div className="gpt3__navbar-menu_container-links">
                <Menu />
                <div className="gpt3__navbar-menu_container-links-sign">
                  <motion.p
                    whileHover={{
                      scale: 1.1,
                    }}
                  >
                    Sign in
                  </motion.p>
                  <motion.button
                    whileHover={{
                      scale: 1.1,
                    }}
                  >
                    Sign up
                  </motion.button>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <motion.div className="progress-bar" style={{ scaleX: scaleX }} />
    </motion.div>
  );
};

export default Navbar;
